import { SbBlokData } from "@storyblok/react";

interface RichTextContent {
  type: string;
  content?: { text: string }[];
}

interface RichTextElement extends SbBlokData {
  content?: {
    content?: RichTextContent[];
  };
}

export const getDescriptionFromBody = (body: SbBlokData[]) => {
  // Check whether there is a RichText element in the body.
  const richTextElement = body?.find(
    (element) => element.component === "RichText"
  ) as RichTextElement | undefined;
  if (!richTextElement?.content?.content) {
    return null;
  }

  // Check whether there is a paragraph in the RichText.
  const paragraph = richTextElement.content?.content.find(
    (element) => element.type === "paragraph"
  );
  if (!paragraph?.content) {
    return null;
  }

  return paragraph?.content[0].text;
};
